/**
 * Page Visibility API wrapper.
 *
 * `isTabVisible()` reads the document directly, so any bundle can call it without waiting for the
 * tracking to be started. `startTabVisibilityTracking()` is called once, from the main bundle, and
 * publishes the changes on the global event bus.
 */

import globalEventBus, { GLOBAL_EVENTS } from 'shared/globalEventBus';

const [HIDDEN_PROPERTY, VISIBILITY_CHANGE_EVENT] = (() => {
    if (typeof document.hidden !== 'undefined') { // Opera 12.10 and Firefox 18 and later support
        return ['hidden', 'visibilitychange'];
    }
    if (typeof document.msHidden !== 'undefined') {
        return ['msHidden', 'msvisibilitychange'];
    }
    if (typeof document.webkitHidden !== 'undefined') {
        return ['webkitHidden', 'webkitvisibilitychange'];
    }
    return [undefined, undefined];
})();

function isTabVisible () {
    if (HIDDEN_PROPERTY === undefined) {
        return true;
    }
    return !document[HIDDEN_PROPERTY];
}

function startTabVisibilityTracking () {
    if (HIDDEN_PROPERTY === undefined) {
        console.log('This requires a browser, such as Google Chrome or Firefox, that supports the Page Visibility API.');
        return;
    }
    const onVisibilityChange = () => globalEventBus.emit(GLOBAL_EVENTS.TAB_VISIBILITY_CHANGED, isTabVisible());
    document.addEventListener(VISIBILITY_CHANGE_EVENT, onVisibilityChange, false);
    onVisibilityChange();
}

export { isTabVisible, startTabVisibilityTracking };
export default startTabVisibilityTracking;
